import React from "react";
export default () => <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 1L7.5 7.22222L14 1" stroke="#364AD4" strokeWidth="2"/>
  <path d="M1 8.25928L7.5 14.4815L14 8.25928" stroke="#364AD4" strokeWidth="2"/>
</svg>
